import { Observable } from 'rxjs';
import { NoteModel } from '../../models/note.model';

export abstract class BaseNoteService {

  public abstract getNotesForProgram(userID: string, baseUrl?: string): Observable<NoteModel[]>;

  public abstract updateNotes(notes: any, baseUrl?: string): Observable<any>;
}
